<template>
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
    <!-- If loading is true, render 4 loading stat cards -->
    <template v-if="loading">
      <DashboardStatCard
        v-for="i in 4"
        :key="`skeleton-${i}`"
        :stat="{}"
        :loading="true"
      />
    </template>

    <!-- Else, render actual stat cards -->
    <template v-else>
      <DashboardStatCard
        v-for="stat in stats"
        :key="stat.label"
        :stat="stat"
        :loading="false"
      />
    </template>
  </div>
</template>

<script>
import DashboardStatCard from "./DashboardStatCard.vue";

export default {
  name: "DashboardStats",
  components: { DashboardStatCard },
  props: {
    stats: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
